import React, { useState } from "react"
import { StyleSheet, TextInput as NativeTextInput } from "react-native"
import { TextInput } from "react-native-paper"
import { baseColors } from "@Constants/baseStyles"

export const MultilineInput = (props) => {
    const [isFocused, setIsFocused] = useState(false)

    return (
        <TextInput
            multiline
            disabled={props.disabled}
            value={props.value}
            onChangeText={props.onChange}
            placeholder={props.placeholder || "Tapez votre texte"}
            textAlignVertical={"top"}
            render={(innerProps) => (
                <NativeTextInput
                    placeholderTextColor={baseColors.grey}
                    placeholder={props.placeholder || "Tapez votre texte"}
                    {...innerProps}
                    style={{
                        ...styles.textInput,
                        height: props.height || 195
                    }}
                />
            )}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            theme={{
                roundness: 10,
                colors: {
                    text: baseColors.green.primary,
                    primary: props.defaultPrimaryColor ?? baseColors.orange.primary,
                    background: props.defaultPrimaryColor || !isFocused ? baseColors.white : baseColors.orange.light
                }
            }}
            mode="outlined"
            style={{
                marginVertical: props.marginVertical ?? undefined
            }}
        ></TextInput>
    )
}

const styles = StyleSheet.create({
    textInput: { color: baseColors.green.dark, paddingHorizontal: 8, paddingTop: 8, paddingBottom: 8 }
})
